import classNames from 'classnames'
import './styles.scss'
import VirtualTour from '../virtual-tour'
import { data } from '../../data'
import { useVehicleContext } from '../../hooks/useVehicleContext'

function ScreenOverlay({ show = false, onClose = () => {}, mode, setMode }) {
  const { vehicleType } = useVehicleContext()

  return (
    <div
      className={classNames({
        'screen-overlay': true,
        'screen-overlay--show': show,
      })}
    >
      <VirtualTour
        onClose={onClose}
        tab={mode}
        setTab={setMode}
        config={data[vehicleType]}
      />
    </div>
  )
}

export default ScreenOverlay
